import { getRecord, putRecord } from "./db";
export const mealChoices = [
	["shrimp", "새우", "えび"],
	["cashew", "캐슈너트", "カシューナッツ"],
	["crab", "게", "かに"],
	["walnut", "호두", "くるみ"],
	["wheat", "밀", "小麦"],
	["buckwheat", "메밀", "そば"],
	["egg", "달걀", "卵"],
	["milk", "우유", "乳"],
	["peanut", "땅콩", "落花生"],
	["pork", "돼지고기", "豚肉"],
	["alcohol", "술", "アルコール"],
	["vegetarian", "채식", "肉・魚"],
] as const;
export type DeviceProfile = { id: "device"; meals: string[]; sound: boolean };
export async function getProfile(): Promise<DeviceProfile> {
	const v = await getRecord<DeviceProfile>("profile", "device");
	if (!v) return { id: "device", meals: [], sound: false };
	if (
		!Array.isArray(v.meals) ||
		!v.meals.every((k) => mealChoices.some((c) => c[0] === k)) ||
		typeof v.sound !== "boolean"
	)
		throw new Error("INVALID_PROFILE");
	return v;
}
export async function saveProfile(v: DeviceProfile) {
	if (!v.meals.every((k) => mealChoices.some((c) => c[0] === k)))
		throw new Error("INVALID_PROFILE");
	await putRecord("profile", v);
}
